module.exports = __webpack_public_path__ + "img/back-ground@2x.5b6c21b7.png";